import { render, staticRenderFns } from "./addedit-hazard.vue?vue&type=template&id=2ce6a576"
import script from "./addedit-hazard.vue?vue&type=script&lang=js"
export * from "./addedit-hazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports